import styled from 'styled-components';

export const StepBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1rem;
	flex: 1 1 auto;
	min-height: 0;
`;
